import { createContext, useContext } from 'react';

export interface DataImportContextValue {
  isAdmin: boolean;
  /**
   * Báo lỗi API bằng notification. Riêng 409 DATA_IMPORT_NOT_ALLOWED (vừa bị thu quyền)
   * thì chuyển cả trang sang khối "Bạn chưa được cấp quyền nhập dữ liệu"; 409
   * STUDIO_ROUTE_BLOCKED (cổng Studio) cũng chuyển sang khối đó, kèm câu của máy chủ.
   */
  reportError: (err: unknown, title: string) => void;
}

export const DataImportContext = createContext<DataImportContextValue>({
  isAdmin: false,
  reportError: () => undefined,
});

export const useDataImport = () => useContext(DataImportContext);
